import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { DestinationSearchStimulusModel } from "../../../../scripts/_generated/DestinationSearchStimulusModel";
import { configureTypeaheadAutocomplete } from "../../../../scripts/typeaheadHelper";
import { SearchDestinationDto } from "../../../../scripts/_generated/SearchDestinationDto";
import { stringFormat } from "../../../../scripts/helpers";

export const destinationSelectedEventName = "destinationSelected";
export const noDestinationsFoundEventName = "noDestinationsFound";

export default class DestinationSearchController extends BaseStimulusModelController<DestinationSearchStimulusModel> {
    static targets = [
        "destination",
        "destinationUniqueId",
    ];

    readonly destinationTargets!: HTMLElement[]; // collection needed - typeahead creates another input
    readonly destinationUniqueIdTarget!: HTMLInputElement;

    connect() {
        this.configureDestinationSearch();
    }

    private configureDestinationSearch() {
        configureTypeaheadAutocomplete(
            this.modelValue.searchDestinationUrl,
            $(this.destinationTargets),
            $(this.destinationUniqueIdTarget),
            destination => this.modelValue.searchResultDisplayFormat
                ? stringFormat(this.modelValue.searchResultDisplayFormat, destination.destinationName, destination.destinationUniqueId)
                : `${destination.destinationName}`,
            "destinationUniqueId",
            "$destinationNameOrUniqueId",
            () => {
                this.dispatch(noDestinationsFoundEventName);                
            }
        );

        $(this.destinationTargets).on('typeahead:select', (e, searchDestinationDto: SearchDestinationDto) => {
            this.dispatch(destinationSelectedEventName, { detail: searchDestinationDto });
        });
    }
}

